<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">체인점관리</span>
            <span class="txt">
                가입된 업체 중 여러 지점을 갖고 있는 체인점의 경우, 본사와 지점을 선택하고 묶을 수 있는 설정을 하여,
                본사의 대표운영자가 지점에 대한 영역까지 관리할 수 있습니다.
            </span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-search-input">
                    <input v-model="chainSearchStr" placeholder="센터명" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>
        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn blue" href="#" @click="onClickRegistChainPopup">체인점 등록</a>
                </div>
            </div>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 188px" />
                    <col style="width: 600px" />
                    <col style="width: 208px" />
                    <col style="width: 420px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>본점</th>
                        <th>센터수</th>
                        <th>최고권한</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="chain in chainList">
                        <td>{{ chain.c_cre_dt | timestampFilter }}</td>
                        <td>{{ chain.c_center_nm }}</td>
                        <td>{{ chain.cc_center_cnt }}</td>
                        <td>{{ convertStaffsStr(chain.centerStaffs) }}</td>
                        <td>
                            <button class="com-btn" @click="updateChainPopup(chain.c_chain_id)">수정</button>
                        </td>
                    </tr>
                    <tr v-if="chainList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="chainPagingInfo.page"
            :per-page="chainPagingInfo.limit"
            :total-rows="chainPagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event, 'chain')"
        ></b-pagination>

        <!-- 체인점 등록 레이어 팝업 -->
        <div v-if="chainPop === true" class="layer-pop square">
            <div class="view-content w655">
                <button class="close" @click="onClickCloseChainPopup"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">체인점 등록</span>
                    <table class="com-table col-style-2">
                        <colgroup>
                            <col style="width: 160px" />
                            <col style="width: 390px" />
                        </colgroup>
                        <loading-spinner v-if="chainIsLoading"></loading-spinner>
                        <tbody v-else>
                            <tr>
                                <td>본점</td>
                                <td>
                                    <div class="com-input-txt">
                                        <input
                                            maxlength="0"
                                            placeholder="센터명을 입력하세요"
                                            type="text"
                                            @click="popupCenterSearch('M')"
                                        />
                                        <button class="com-btn" @click="popupCenterSearch('M')">검색</button>
                                    </div>
                                    <ul class="select-info-list">
                                        <li v-if="mCenter.length !== 0">
                                            <span v-if="mCenter.hasOwnProperty('centerName')" class="txt">
                                                {{ mCenter.centerName }} / {{ mCenter.telNo | phoneNumberFilter }}
                                                <button class="del-btn" v-on:click="delMCenter"></button>
                                            </span>
                                            <span v-else-if="mCenter.hasOwnProperty('c_center_nm')" class="txt">
                                                {{ mCenter.c_center_nm }} / {{ mCenter.c_tel_no | phoneNumberFilter }}
                                                <button class="del-btn" v-on:click="delMCenter"></button>
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>지점</td>
                                <td>
                                    <div class="com-input-txt">
                                        <input
                                            maxlength="0"
                                            placeholder="센터명을 입력하세요"
                                            type="text"
                                            @click="popupCenterSearch('C')"
                                        />
                                        <button class="com-btn" @click="popupCenterSearch('C')">검색</button>
                                    </div>
                                    <ul class="select-info-list">
                                        <li v-for="cCenter in cCenterList">
                                            <span v-if="cCenter.hasOwnProperty('centerName')" class="txt">
                                                {{ cCenter.centerName }} / {{ cCenter.telNo | phoneNumberFilter }}
                                                <button class="del-btn" v-on:click="delCCenter(cCenter.id)"></button>
                                            </span>
                                            <span v-else-if="cCenter.hasOwnProperty('c_center_nm')" class="txt">
                                                {{ cCenter.c_center_nm }} / {{ cCenter.c_tel_no | phoneNumberFilter }}
                                                <button class="del-btn" v-on:click="delCCenter(cCenter.c_id)"></button>
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>최고권한</td>
                                <td>
                                    <div class="com-input-txt">
                                        <input
                                            maxlength="0"
                                            placeholder="이름을 입력하세요"
                                            type="text"
                                            @click="popupStaffSearch"
                                        />
                                        <button class="com-btn" @click="popupStaffSearch">검색</button>
                                    </div>
                                    <ul class="select-info-list">
                                        <li v-for="(s, index) in selectedStaffList" :key="index">
                                            <span v-if="s.hasOwnProperty('c_center_id')" class="txt">
                                                {{ s.c_namee }} / {{ s.c_phone | phoneNumberFilter }}
                                                <button
                                                    class="del-btn"
                                                    v-on:click="delStaff(s.c_center_staff_id)"
                                                ></button>
                                            </span>
                                            <span v-if="s.hasOwnProperty('centerId')" class="txt">
                                                {{ s.name }} / {{ s.phone | phoneNumberFilter }}
                                                <button class="del-btn" v-on:click="delStaff(s.centerStaffId)"></button>
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancleBtn">취소</button>
                        <button v-if="chainId" class="com-btn blue" @click="registerChain">수정</button>
                        <button v-else class="com-btn blue" @click="registerChain">등록</button>
                        <button class="com-btn red" @click="onClickDeleteChain">삭제</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 센터 검색 팝업 -->
        <div v-if="centerPop" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">센터 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input
                                ref="refCenterName"
                                v-model="centerNameKeyword"
                                class="w220"
                                placeholder="센터명"
                                type="text"
                                v-on:keyup.enter="onEventSearchCenter"
                            />
                            <button class="com-btn" @click="onEventSearchCenter">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 280px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>센터명</th>
                                <th>연락처</th>
                            </tr>
                        </thead>
                        <loading-spinner v-if="centerIsLoading"></loading-spinner>
                        <tbody v-else>
                            <tr v-for="center in searchCenterList" :key="center.id">
                                <td>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-pop-${center.id}`"
                                            v-model="selectedCenter"
                                            :value="center"
                                            name="radio-pop"
                                            type="radio"
                                        />
                                        <label :for="`radio-pop-${center.id}`"></label>
                                    </div>
                                </td>
                                <td>{{ center.centerName }}</td>
                                <td>{{ center.telNo | phoneNumberFilter }}</td>
                            </tr>
                            <tr v-if="searchCenterList.length === 0">
                                <td colspan="100">검색 결과가 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        v-model="centerPagingInfo.page"
                        :per-page="centerPagingInfo.limit"
                        :total-rows="centerPagingInfo.totalItems"
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                        @change="handlerPagenation($event, 'center')"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="cancelCenterPopup">취소</button>
                        <button class="com-btn blue" @click="centerPick">선택</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 직원 검색 팝업 -->
        <div v-if="staffPop" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">직원 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input
                                ref="refStaffName"
                                v-model="staffSearchStr"
                                class="w220"
                                placeholder="이름"
                                type="text"
                                v-on:keyup.enter="onEventSearchStaff"
                            />
                            <button class="com-btn" @click="onEventSearchCenter">검색</button>
                        </div>
                    </div>
                    <loading-spinner v-if="staffIsLoading"></loading-spinner>
                    <table v-else class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 280px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>이름</th>
                                <th>연락처</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="c in searchStaffList" :key="c.c_center_staff_id">
                                <td>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-pop-${c.c_center_staff_id}`"
                                            v-model="selectedStaff"
                                            :value="c"
                                            name="radio-pop"
                                            type="radio"
                                        />
                                        <label :for="`radio-pop-${c.c_center_staff_id}`"></label>
                                    </div>
                                </td>
                                <td>{{ c.c_namee }}</td>
                                <td>{{ c.c_phone | phoneNumberFilter }}</td>
                            </tr>
                            <tr v-if="searchStaffList.length === 0">
                                <td colspan="100">검색 결과가 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        v-model="staffPagingInfo.page"
                        :per-page="staffPagingInfo.limit"
                        :total-rows="staffPagingInfo.totalItems"
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                        @change="handlerPagenation($event, 'staff')"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="cancelStaffPopup">취소</button>
                        <button class="com-btn blue" @click="staffPick">선택</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../../assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
    name: 'businessChainList',
    components: { LoadingSpinner },
    props: {},
    computed: {
        rows() {
            return this.items.length;
        },
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    data() {
        return {
            value: '',
            isLoading: false,
            chainIsLoading: false, // 체인점 등록, 수정 팝업 로딩
            centerIsLoading: false, // 본점, 지점 센터 검색 팝업 로딩
            staffIsLoading: false, // 최고 권한 검색 팝업 로딩
            chainId: '', // 체인점 수정시 chain_id 값
            chainSearchStr: '', // 체인 검색 센터명 파라미터
            chainList: [],
            chainPop: false, // 체인점 등록 화면 팝업 여부
            centerPop: false, // 센터 검색 화면 팝업 여부
            staffPop: false, // 직원 검색 화면 팝업 여부
            selectedCenter: {}, // 센터 검색을 통해 선택한 센터 정보 (임시)
            selectedStaff: {}, // 직원 검색을 통해 선택한 직원 정보
            centerType: '', // 센터 검색 종류 (M : 본점 검색, C : 지점 검색)
            centerNameKeyword: '', // 센터명 검색 파라미터
            staffSearchStr: '', // 직원명 검색 파라미터
            searchCenterList: [], // 센터명으로 검색된 센터 목록
            searchStaffList: [], // 직원 이름으로 검색된 직원 목록
            mCenter: '', // 선택된 본점
            cCenterList: [], // 선택된 지점 목록
            selectedStaffList: [], // 선택된 직원 목록
            currentPage: 1,
            perPage: 1,
            chainPagingInfo: {
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            },
            centerPagingInfo: {
                // 직원 페이징 정보
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            },
            staffPagingInfo: {
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            },
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
        };
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            this.fetchChainList();
        } else {
            alert('권한이 없습니다.');
            this.$router.push('/care/login');
        }
    },
    methods: {
        // 체인점 목록 조회 API 호출
        sendGetChainList() {
            return api.get('/admin/api/centerChain', {
                params: {
                    centerType: 'M',
                    searchStr: this.chainSearchStr,
                    ...this.chainPagingInfo,
                },
            });
        },

        // 체인점 목록 가져오기
        async fetchChainList() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetChainList();
                this.setPageParams(data, 'chain');
                this.chainList = data.items;
                console.log('===> 체인점 목록 조회 : ', data);
                this.isLoading = false;
            } catch (error) {
                alert('체인점 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 이벤트 발생시 키워드 길이 체크
        onEventSearch(e) {
            if (this.chainSearchStr.length < 2) {
                return;
            }
            this.fetchChainList();
        },

        // 체인점 등록 팝업
        onClickRegistChainPopup() {
            this.chainPop = true;
        },

        // 체인점 등록 팝업 취소 버튼 클릭시
        onClickCloseChainPopup() {
            this.chainPop = false;
            this.mCenter = '';
            this.cCenterList = [];
            this.chainId = '';
        },

        // 센터 검색 팝업
        popupCenterSearch(type) {
            // 페이징 param 초기화
            this.centerPagingInfo = {
                // 직원 페이징 정보
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            };
            if (type === 'M') {
                this.centerType = 'M';
            } else if (type === 'C') {
                this.centerType = 'C';
            }
            this.centerPop = true;
            this.$nextTick(function () {
                this.$refs.refCenterName.focus(); // 센터명 ref focus
            });
        },

        // 직원 검색 팝업
        popupStaffSearch() {
            // 본점과 지점이 선택되지 않았으면 먼저 선택하라는 alert 띄움
            if (this.mCenter === '' && this.cCenterList.length === 0) {
                alert('본점이나 지점을 하나 이상 선택하세요.');
                return false;
            }

            // 페이징 param 초기화
            this.staffPagingInfo = {
                // 직원 페이징 정보
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            };
            this.staffPop = true;
            this.$nextTick(function () {
                this.$refs.refStaffName.focus(); // 직원명 ref focus
            });
        },

        // 센터 검색 팝업 취소
        cancelCenterPopup() {
            this.centerPop = false;
            this.searchCenterList = [];
            this.centerNameKeyword = '';
            this.centerId = '';
        },

        // 직원 검색 팝업 취소 버튼 클릭시
        cancelStaffPopup() {
            this.staffPop = false;
            this.searchStaffList = [];
            this.staffSearchStr = '';
            this.selectedStaff = {};
        },

        // 센터 목록 가져오기
        async searchCenter() {
            try {
                const { data } = await this.sendGetCenterList();
                this.setPageParams(data, 'center');
                this.searchCenterList = data.items;
            } catch (error) {
                alert('센터 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 목록 조회 API 호출
        sendGetCenterList() {
            return api.get('/admin/api/center', {
                params: {
                    searchStr: this.centerNameKeyword,
                    ...this.centerPagingInfo,
                },
            });
        },

        // 이벤트 발생시 키워드 길이 체크
        onEventSearchCenter(e) {
            if (this.centerNameKeyword.length < 2) {
                return;
            }
            this.searchCenter();
        },

        // 페이징 Param 설정
        setPageParams(data, type) {
            if (type === 'chain') {
                this.chainPagingInfo.totalPages = data.meta.totalPages;
                this.chainPagingInfo.page = data.meta.currentPage;
                this.chainPagingInfo.totalItems = data.meta.totalItems;
                this.chainPagingInfo.itemCount = data.meta.itemCount;
            } else if (type === 'center') {
                this.centerPagingInfo.totalPages = data.meta.totalPages;
                this.centerPagingInfo.page = data.meta.currentPage;
                this.centerPagingInfo.totalItems = data.meta.totalItems;
                this.centerPagingInfo.itemCount = data.meta.itemCount;
            } else if (type === 'staff') {
                this.staffPagingInfo.totalPages = data.meta.totalPages;
                this.staffPagingInfo.page = data.meta.currentPage;
                this.staffPagingInfo.totalItems = data.meta.totalItems;
                this.staffPagingInfo.itemCount = data.meta.itemCount;
            }
        },

        // 페이지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'center') {
                this.centerPagingInfo.page = event;
                this.searchCenter();
            } else if (pagingType === 'chain') {
                this.chainPagingInfo.page = event;
                this.fetchChainList();
            } else if (pagingType === 'staff') {
                this.staffPagingInfo.page = event;
                this.fetchStaffList();
            }
        },

        // row count 변경
        changeLimit(val) {
            this.chainPagingInfo.limit = val;
            this.fetchChainList();
        },

        // 본점, 지점 선택 버튼 클릭시
        centerPick() {
            if (Object.keys(this.selectedCenter).length === 0) {
                alert('센터를 선택하세요.');
                return;
            }
            if (this.centerType === 'M') {
                if (this.mCenter.id === this.selectedCenter.id || this.mCenter.c_id === this.selectedCenter.id) {
                    alert('이미 추가된 본점입니다.');
                    return;
                }
                this.mCenter = this.selectedCenter;
            } else if (this.centerType === 'C') {
                const findCCenter = this.cCenterList.find(
                    (cCenter) => cCenter.id === this.selectedCenter.id || cCenter.c_id === this.selectedCenter.id
                );
                const findMCenter =
                    this.mCenter.id === this.selectedCenter.id || this.mCenter.c_id === this.selectedCenter.id;
                if (findCCenter === undefined && findMCenter === false) {
                    this.cCenterList.push(this.selectedCenter);
                } else if (findMCenter === true) {
                    alert('본점으로 등록된 센터입니다.');
                    return;
                } else {
                    alert('이미 추가된 지점입니다.');
                    return;
                }
            }
            this.centerPop = false;
            this.centerType = '';
            this.searchCenterList = [];
            this.centerNameKeyword = '';
            this.selectedCenter = {};
        },

        // 직원 검색 후 선택 버튼 클릭시
        staffPick() {
            if (Object.keys(this.selectedStaff).length === 0) {
                alert('직원을 선택하세요.');
                return;
            }
            this.selectedStaffList.push(this.selectedStaff);
            this.staffPop = false;
            this.searchStaffList = [];
            this.staffSearchStr = '';
            this.selectedStaff = {};
        },

        // 본점 삭제
        delMCenter() {
            this.mCenter = '';
        },

        // 지점 삭제
        delCCenter(selectedId) {
            const idx = this.cCenterList.findIndex((cCenter) => cCenter.id === selectedId);
            if (idx >= -1) {
                this.cCenterList.splice(idx, 1);
            }
        },

        // 최고 권한 직원 삭제 버튼 클릭시
        delStaff(delStaffId) {
            const idx = this.selectedStaffList.findIndex((staff) => staff.c_center_staff_id === delStaffId);
            if (idx >= -1) {
                this.selectedStaffList.splice(idx, 1);
            }
        },

        // 체인점 등록 API 호출
        async callCreateChain(centerList) {
            api.post('/admin/api/centerChain', {
                ...centerList,
            })
                .then((response) => {
                    console.log('===> Success Chain create : ', response);
                    console.log('===> centerList', centerList.centerIdList);
                    !this.chainId ? alert('체인점이 등록 되었습니다.') : alert('체인점이 수정 되었습니다.');
                    this.chainPop = false;
                    this.cCenterList = [];
                    this.mCenter = '';
                    this.selectedStaffList = [];
                    this.fetchChainList();
                })
                .catch(({ message }) => {
                    alert('체인점 등록 실패했습니다.');
                    console.log('===> Failed Chain create : ', message);
                    console.log(centerList);
                });
        },

        // 체인점 수정 API 호출
        async callUpdateChain(centerList) {
            api.put(`/admin/api/centerChain/${this.chainId}`, {
                ...centerList,
            })
                .then((response) => {
                    console.log('===> Success Chain create : ', response);
                    console.log('===> centerList', centerList.centerIdList);
                    !this.chainId ? alert('체인점이 수정 되었습니다.') : alert('체인점이 수정 되었습니다.');
                    this.chainPop = false;
                    this.cCenterList = [];
                    this.mCenter = '';
                    this.selectedStaffList = [];
                    this.fetchChainList();
                })
                .catch(({ message }) => {
                    alert('체인점 등록 실패했습니다.');
                    console.log('===> Failed Chain create : ', message);
                    console.log(centerList);
                });
        },

        // 체인 등록
        async registerChain() {
            if (this.mCenter.length === 0) {
                alert('본점을 선택해주세요.');
                return;
            }
            if (this.cCenterList.length === 0) {
                alert('지점을 선택해주세요.');
                return;
            }
            if (this.selectedStaffList.length === 0) {
                alert('최고권한을 선택해주세요.');
            }

            const centerList = {
                centerIdList: [],
                chainStaffList: [],
            };

            centerList.centerIdList.push(this.mCenter.id);

            this.cCenterList.forEach((cCenter) => {
                centerList.centerIdList.push(cCenter.id);
            });

            this.selectedStaffList.forEach((staff) => {
                let temp;

                if (staff.hasOwnProperty('c_center_id')) {
                    temp = {
                        centerId: staff.c_center_id,
                        centerStaffId: staff.c_center_staff_id,
                    };
                } else if (staff.hasOwnProperty('centerId')) {
                    temp = {
                        centerId: staff.centerId,
                        centerStaffId: staff.centerStaffId,
                    };
                }
                centerList.chainStaffList.push(temp);
            });

            if (this.chainId) {
                // chainId가 있으면 체인점 수정
                await this.callUpdateChain(centerList);
            } else {
                // 없으면 체인점 등록
                await this.callCreateChain(centerList);
            }
        },

        // 체인점 수정 버튼 클릭시
        async updateChainPopup(chainId) {
            this.chainIsLoading = true;
            this.chainPop = true;
            this.chainId = chainId;
            await this.fetchChainDetail(chainId);
            this.chainIsLoading = false;
        },

        // 체인점 센터 정보 가져오기
        async fetchChainDetail(chainId) {
            try {
                const { data } = await this.sendGetChainCenter(chainId);
                console.log(data);
                const centerlist = data.centers;
                this.mCenter = centerlist[0]; // 리스트의 첫번째 센터는 본점
                centerlist.splice(0, 1); // 첫번째 센터는 삭제하고,
                this.cCenterList = centerlist; // 나머지는 지점 리스트에 넣음

                this.selectedStaffList = data.adminStaffs;
            } catch (error) {
                alert('체인점 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 체인점 상세조회 API 호출
        sendGetChainCenter(chainId) {
            return api.get(`/admin/api/centerChain/${chainId}`);
        },

        // 체인 삭제 API
        deleteChain(chainId) {
            return api.delete(`/admin/api/centerChain/${chainId}`);
        },

        // 체인 삭제 버튼 클릭
        async onClickDeleteChain() {
            try {
                const { data } = await this.deleteChain(this.chainId);
                console.log('===> Success Chain Delete', data);
                alert('체인점을 삭제했습니다.');
                this.cCenterList = [];
                this.mCenter = '';
                this.chainId = '';
                this.chainPop = false;
                this.fetchChainList();
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 체인점 등록, 수정 취소 버튼 클릭
        onClickCancleBtn() {
            this.chainPop = false;
            this.cCenterList = [];
            this.mCenter = '';
            this.chainId = '';
            this.fetchChainList();
        },

        // 직원 목록 검색 이벤트
        onEventSearchStaff() {
            this.fetchStaffList();
        },

        // 본점과 지점으로 선택된 센터의 직원 목록 가져오기
        async fetchStaffList() {
            try {
                this.staffIsLoading = true;
                const { data } = await this.sendGetStaffList();
                this.setPageParams(data, 'staff');
                this.searchStaffList = data.items;
                this.staffIsLoading = false;
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 체인점 직원 목록조회(페이징) API 호출
        sendGetStaffList() {
            const centerIds = [];
            if (this.mCenter !== '') {
                // 선택된 본점이 있으면
                centerIds.push(this.mCenter.id);
            }
            if (this.cCenterList.length !== 0) {
                // 선택된 지점이 있으면
                this.cCenterList.forEach((c) => {
                    centerIds.push(c.id);
                });
            }

            return api.get('/admin/api/center/1/staff/chain/pagaing', {
                params: {
                    ...this.staffPagingInfo,
                    searchStr: this.staffSearchStr,
                    chainCenterId: centerIds.join(','),
                },
            });
        },

        // 화면에 표시되는 최고권한 String 변환
        convertStaffsStr(centerStaffs) {
            if (centerStaffs === undefined || centerStaffs.length === 0) {
                return '-';
            }
            let result;

            if (centerStaffs.length === 1) {
                // 최고권한 직원이 1명일 경우
                result = `${centerStaffs[0].name} (${centerStaffs[0].email})`;
            } else if (centerStaffs.length > 1) {
                // 최고권한 직원이 2명 이상일 경우
                result = `${centerStaffs[0].name} (${centerStaffs[0].email})` + ` 외 ${centerStaffs.length - 1}명`;
            }

            return result;
        },
    },
};
</script>
<style lang="scss"></style>
